<script setup lang="ts">
import './assets/style.scss'
import { ref } from 'vue'
import { VIcons } from '@/shared/ui'
import { ObjectSearchTree } from '@/widgets'
import { ObjectsTree } from '@/entities/ObjectsTree'
import { ScheduleCreateButton } from '@/features/Schedule/ScheduleCreate'
import { SchedulesTree } from '@/entities/SchedulesTree'
import { useAuth } from '@/entities/Auth'

const tab = ref('obj')
const sideBarIsClose = defineModel<boolean>()
const { isTab } = useAuth()

const closeHandler = () => (sideBarIsClose.value = !sideBarIsClose.value)
</script>

<template>
  <VNavigationDrawer
    :width="300"
    absolute
    class="w-side-bar"
    mobile-breakpoint="md"
    v-model="sideBarIsClose"
  >
    <template #prepend>
      <VTabs v-model="tab" density="compact" color="white" class="w-side-bar__tab">
        <VTab value="obj">{{ $t('itf.structure') }}</VTab>
        <VTab v-if="isTab('SCHEDULES')" value="skd">{{ $t('itf.schedule') }}</VTab>
      </VTabs>

      <VDivider />
    </template>

    <template #append>
      <div
        class="w-side-var__close-btn"
        :class="{ 'w-side-var__close-btn_compact': !sideBarIsClose }"
        @click="closeHandler"
      >
        <VIcons type="more_vert" />
        <VIcons type="double_arrow" class="w-side-var__icon" />
        <VIcons type="more_vert" />
      </div>
    </template>

    <VTabsWindow v-model="tab" class="mt-2">
      <VTabsWindowItem value="obj">
        <ObjectSearchTree class="mt-2" />

        <ObjectsTree />
      </VTabsWindowItem>

      <VTabsWindowItem value="skd">
        <ScheduleCreateButton class="mt-2 mb-2" />

        <SchedulesTree />
      </VTabsWindowItem>
    </VTabsWindow>
  </VNavigationDrawer>
</template>
